import { zodValidator, type TypedFetch } from "@spiriidk/utils";

import { LogoSchema } from "../../schemas/logo";

const getLogo = async (fetch: TypedFetch, signal?: AbortSignal) =>
  fetch.get("/admin/logo", {
    validateResponse: zodValidator(LogoSchema),
    signal,
  });

export { getLogo };
